import { Link } from 'react-router';
import { Bot } from 'lucide-react';
import { useOrdersSignalR } from '@/features/orders/hooks/useOrdersSignalR';
import { useConversationsAccess } from '../hooks/useConversationsAccess';
import { useCustomerAgentStatus } from '../hooks/useConversations';
import { customerAgentStatusNotice } from '../lib/customer-agent-status-notice';
import styles from './ConversationAlerts.module.css';

/* ==========================================================================
   Faixa de estado do Atendente IA (change customer-agent-handoff, D20)

   Lê `GET /api/v1/customer-agent/status` (revalidado pela campainha
   `customer_agent.status_changed`, na reconexão e a cada 5 min) e só aparece
   quando o atendente parou por algo que a loja não escolheu: a Vapt pausou,
   o provedor caiu ou o teto de uso do mês acabou. Os demais estados têm outro
   lugar: `no_units` é da faixa dos atendimentos, `not_connected` da faixa do
   WhatsApp, e `paused`, `disabled` e `plan_required` são escolha do dono,
   mostrados só no cabeçalho do Atendimento.
   ========================================================================== */

/** Só para quem tem `conversations.read` com a área do Atendente IA disponível. */
export function CustomerAgentStatusBar() {
  const { available } = useConversationsAccess();
  if (!available) return null;
  return <CustomerAgentStatusBarContent />;
}

function CustomerAgentStatusBarContent() {
  // A campainha `customer_agent.status_changed` e a reconexão chegam pela
  // conexão compartilhada de pedidos, que a faixa mantém aberta.
  useOrdersSignalR();
  const { data: status } = useCustomerAgentStatus();
  const notice = customerAgentStatusNotice(status);
  if (!notice) return null;
  return (
    <div className={styles.statusBar} role="status" data-testid="customer-agent-status-bar" data-state={notice.state}>
      <Bot size={16} className={styles.icon} aria-hidden="true" />
      <span className={styles.text}>{notice.text}</span>
      {notice.link && (
        <Link to={notice.link.to} className={styles.link}>
          {notice.link.label}
        </Link>
      )}
    </div>
  );
}
